<template>
    <div class="">
        <el-menu
                class="menu_navs"
                background-color="#344040"
                text-color="#ccc"
                :unique-opened="true"
                active-text-color="#fff">
            <template v-for="item in navs" >
                <el-submenu :index="item.id + ''" v-if="item.children" :key="item.id">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span>{{item.name}}</span>
                    </template>
                    <el-menu-item v-for="sub in item.children"  :index="sub.id + ''" :key="sub.id" @click="openPage(sub)">
                        {{sub.name}}
                    </el-menu-item>
                </el-submenu>
                <el-menu-item v-else :index="item.id + ''" :key="item.id" @click="openPage(item)">
                    <i :class="item.icon"></i>
                    <span slot="title">{{item.name}}</span>
                </el-menu-item>
            </template>
        </el-menu>


    </div>
</template>

<style >
    .menu_navs .el-menu {
        border-right: none;
    }

    .menu_navs li * {
        font-size: 16px;
    }
    .menu_navs .el-menu--inline .el-menu-item {
        border-left: 5px solid transparent;
    }
    .menu_navs .el-menu--inline .el-menu-item.is-active {
        border-left:  5px solid var(--primary);
        background: #2b3736 !important;
    }
    .menu_navs > .el-menu-item.is-active {
        background: #2b3736 !important;
    }
    .menu_navs i.iconfont {
        vertical-align: middle;
    }

</style>


<script>
    // // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import {mapState, mapMutations} from "vuex";


    export default {
        components: {
            // HelloWorld
        },
        data() {
            return {
            }

        },

        computed: {
            ...mapState({
                navs: state => state.navs
            })
        },

        methods: {
            ...mapMutations([
                "openTab"
            ]),

            openPage(nav) {
                this.openTab({
                    funcKey:nav.funcKey,
                    attr: null,
                    title: nav.name,
                    allowDuplicate: false});
            }

        },

        created() {

        }

    }
</script>
